import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  UncontrolledTooltip,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import classnames from "classnames"; // Tab sınıfları için
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";

// Firebase Firestore
import { db } from "../../../firebase"; 
import { doc, getDoc, setDoc } from "firebase/firestore";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import "jspdf-autotable";

import {
  addProduct as onAddProduct,
  updateProduct as onUpdateProduct,
  deleteProduct as onDeleteProduct,
} from "store/contacts/actions";
import { isEmpty } from "lodash";

import { useSelector, useDispatch } from "react-redux";

// =============================================================================
// VARSAYILAN ŞABLONLAR (Backend'deki Defaults ile Eşleşmeli)
// =============================================================================


const DEFAULT_SIMULATION_PROMPT = `You are an English speaking evaluator.

MANDATORY PRECHECKS (fail-fast):
Check these conditions in order. If any condition fails, do NOT provide transcript, comments, or scores, return ONLY the relevant Turkish warning message in the JSON.

1) The response must be clearly English (not <non_english_audio>/<unclear_audio> and not mostly non-English).
2) The response must be ethically appropriate: no swearing/insults, no hate speech/discrimination, no violence content, and no political propaganda or directing.
3) The response must directly address the given task/question (no memorized unrelated topic).
4) The response must contain at least 5 sentences.

WARNING MESSAGES (Turkish only):
• Non-English: "İngilizce bir konuşma algılanamadı."
• Inappropriate content: "Uygunsuz içerik tespit edildi. Lütfen uygun bir dil kullanın."
• Off-topic: "Yanıt sorulan soruyla ilgili değildir. Lütfen soruya odaklanın."
• Too short: "Yanıt çok kısadır. Lütfen en az 5 cümlelik bir cevap verin."

EVALUATION (only if all prechecks pass):
Evaluate and score the following skills in this fixed order (0-20):
1) Pronunciation
2) Fluency
3) Grammar and Structure
4) Vocabulary Range
5) Task Completion

Use the official criteria table descriptions (Excellent 17-20, Good 13-16, Limited 9-12, Weak 5-8, Beginner 1-4).

SENTENCE & TIME CAPS (apply only to Grammar, Vocabulary, Task):
- Pronunciation and Fluency are NOT affected by sentence count or duration.
- Apply an upper cap to Grammar/Vocabulary/Task based on sentence count and duration; if both apply, use the LOWER cap.

Table:
• 5-6 sentences: cap 16
• 7-9 sentences: cap 18
• 10+ sentences: cap 20
• 20-39 seconds: cap 12
• 40-59 seconds: cap 16
• 60-90 seconds: cap 20
• >90 seconds: cap 20 (no penalty)

COMMENT RULES:
- For EACH skill, write EXACTLY ONE sentence in Turkish.
- Tone: clear, objective, teacher-like.
- At most one improvement hint per sentence.
- Do NOT mention CEFR/IELTS/band or the Whisper tags.

OVERALL:
overall_score = round((p+f+g+v+t)/5)

MANDATORY JSON OUTPUT ONLY:
{
  "skills": {
    "pronunciation": {"score": number, "comment": "tek cümle"},
    "fluency": {"score": number, "comment": "tek cümle"},
    "grammar_structure": {"score": number, "comment": "tek cümle"},
    "vocabulary_range": {"score": number, "comment": "tek cümle"},
    "task_completion": {"score": number, "comment": "tek cümle"}
  },
  "overall_score": number,
  "motivation": "Türkçe, en fazla 12 kelime",
  "fail_message": "string (only if prechecks fail, otherwise null)"
}
Return ONLY this JSON.
`.trim();

const DEFAULT_PRACTICE_PROMPT = `You are Mr. Bee, an English practice evaluator.

ROLE & TONE:
- Teacher-like, encouraging but direct.
- Short, clear feedback.

MANDATORY RULES (PRACTICE MODE):
1. Write EXACTLY ONE Turkish sentence for each skill.
2. NO color codes, NO CEFR levels, NO long explanations.
3. Identify the ONE "Most Obvious Error" across all skills and provide a specific action for it in the 'motivation' field.

SKILLS TO EVALUATE:
1) Pronunciation
2) Fluency
3) Grammar & Structure
4) Vocabulary Range
5) Task Completion

OUTPUT JSON FORMAT:
{
  "overall_score": number (0-100),
  "scores": {
    "pronunciation": 0,
    "fluency": 0,
    "grammar_structure": 0,
    "vocabulary_range": 0,
    "task_completion": 0
  },
  "feedback": {
    "pronunciation": "Tek cümle Türkçe yorum",
    "fluency": "Tek cümle Türkçe yorum",
    "grammar_structure": "Tek cümle Türkçe yorum",
    "vocabulary_range": "Tek cümle Türkçe yorum",
    "task_completion": "Tek cümle Türkçe yorum"
  },
  "motivation": "En bariz hata ve yapılması gereken (Tek cümle: Sorun -> Çözüm)"
}
`.trim();

// Firestore Yolları
const PROMPT_COLL = "config";
const PROMPT_DOC = "mr_bee_prompt";

const ContactsList = props => {
  document.title = "Yapay Zeka | DLApass Admin PANELI";
  const dispatch = useDispatch();
  
  // Listeleme State'leri
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getSubCategoryID, setSubCategoryID] = useState();
  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getIsActive, setIsActive] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  // ============ PROMPT STATE ============
  const [promptModal, setPromptModal] = useState(false);
  const [activeTab, setActiveTab] = useState("2"); // 1: Test Result, 2: Simulation, 3: Practice
  
  // 3 Farklı Promptu tutacak Obje State
  const [prompts, setPrompts] = useState({
    system: "",
    simulation: "",
    practice: ""
  });

  const [promptSource, setPromptSource] = useState("");
  const [promptLoading, setPromptLoading] = useState(false);
  const [promptSaving, setPromptSaving] = useState(false);

  // Redux Data
  const { users } = useSelector(state => ({
    users: state.contacts.products,
  }));

  // ================= Formik (Liste Ekleme/Düzenleme) =================
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: (contactEdit && contactEdit.Question_SubCategory_Sub_Text) || "",
      sort: (contactEdit && contactEdit.Sort) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().min(3, "En az 3 karakter giriniz").required("Başlığı Giriniz"),
      sort: Yup.number().typeError("Sıralama sayı olmalıdır").nullable(true),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateUser = {
          ID: contactEdit.ID,
          IsActive: getIsActive,
          Sort: values.sort,
          Question_SubCategory_ID: getSubCategoryID,
          Question_SubCategory_Sub_Text: values.title,
        };
        dispatch(onUpdateProduct(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          IsActive: getIsActive,
          Sort: values.sort,
          Question_SubCategory_ID: getSubCategoryID,
          Question_SubCategory_Sub_Text: values.title,
        };
        dispatch(onAddProduct(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const columns = useMemo(() => [
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        Header: "Adı",
        accessor: "Question_SubCategory_Sub_Text",
        filterable: true,
        Cell: cellProps => <NameSurname {...cellProps} />,
      },
      {
        Header: "Alt Kategori Adı",
        accessor: "Question_SubCategory.Question_SubCategory_Title",
        filterable: true,
        Cell: cellProps => <NameSurname {...cellProps} />,
      },
      {
        Header: "Sıralama",
        accessor: "Sort",
        filterable: true,
        Cell: cellProps => <NameSurname {...cellProps} />,
      },
      {
        Header: "Aktif Mi?",
        accessor: "IsActive",
        filterable: true,
        Cell: cellProps => <Status {...cellProps} />,
      },
      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );


  
  useEffect(() => { setContact(users); }, [users]);
  useEffect(() => { if (!isEmpty(users) && !!isEdit) { setContact(users); } }, [users]);
  
  const toggle = () => setModal(!modal);
  const handleUserClick = arg => {
    const user = arg;
    setEditContact(user);
    setSubCategoryID(user.Question_SubCategory_ID);
    setIsActive(user.IsActive);
    setIsEdit(true);
    toggle();
  };
  
  const node = useRef();
  const onPaginationPageChange = page => {
    if ( node && node.current && node.current.props && node.current.props.pagination && node.current.props.pagination.options) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteProduct(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };
  
  /** ================= PROMPT LOGIC (Firebase ile Çoklu Prompt) ================= */
  
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // Firestore'dan verileri çekip 3 promptu doldurur
  const openPromptModal = async () => {
    setPromptModal(true);
    setPromptLoading(true);
    setPromptSource("");
    try {
      const docRef = doc(db, PROMPT_COLL, PROMPT_DOC);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setPrompts({
          simulation: data.simulation_system_prompt || DEFAULT_SIMULATION_PROMPT,
          practice: data.practice_system_prompt || DEFAULT_PRACTICE_PROMPT
        });
        setPromptSource("firestore");
      } else {
        console.warn("Firestore'da prompt dokümanı bulunamadı. Varsayılanlar yükleniyor.");
        setPrompts({
          simulation: DEFAULT_SIMULATION_PROMPT,
          practice: DEFAULT_PRACTICE_PROMPT
        });
        setPromptSource("default");
      }
    } catch (e) {
      console.error("Firestore'dan prompt okunurken hata oluştu:", e);
      window.alert("Promptlar yüklenemedi. Varsayılanlar kullanılıyor.");
      setPrompts({
        simulation: DEFAULT_SIMULATION_PROMPT,
        practice: DEFAULT_PRACTICE_PROMPT
      });
      setPromptSource("default (hata)");
    } finally {
      setPromptLoading(false);
    }
  };

  // 3 Promptu aynı anda kaydeder
const savePrompt = async () => {
  // Sadece simulation ve practice alanlarını kontrol et
  if (!prompts.simulation?.trim() || !prompts.practice?.trim()) {
    window.alert("Lütfen tüm alanları doldurun.");
    return;
  }

  setPromptSaving(true);
  try {
    const docRef = doc(db, PROMPT_COLL, PROMPT_DOC);
    const payload = {
      // system_prompt'u payload'dan çıkarabilir veya mevcut değerini koruyabilirsin
      simulation_system_prompt: prompts.simulation.trim(),
      practice_system_prompt: prompts.practice.trim(),
      updated_at: new Date().toISOString(),
      updated_by: "dlapass_admin_panel",
    };
    await setDoc(docRef, payload, { merge: true }); // merge: true ile sadece gelen alanlar güncellenir
    window.alert("Değişiklikler başarıyla kaydedildi.");
    setPromptModal(false);
  } catch (e) {
    window.alert(`Hata: ${e.message}`);
  } finally {
    setPromptSaving(false);
  }
};


  // Aktif olan Tab'ı varsayılan değere döndürür
  const fillDefaultCurrentTab = () => {
     if (activeTab === "1") {
      setPrompts(prev => ({ ...prev, simulation: DEFAULT_SIMULATION_PROMPT }));
    } else if (activeTab === "2") {
      setPrompts(prev => ({ ...prev, practice: DEFAULT_PRACTICE_PROMPT }));
    }
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          {/* İsim DLApass Olarak Güncellendi */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="DLApass Yapay Zeka" />
          <Row className="mb-3">
            <Col lg="12">
              {/* ---- Prompt Yönetimi Kartı ---- */}
              <Card>
                <CardBody className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="mb-1">DLApass AI Prompt Yönetimi</h5>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      Veri Kaynağı: <b>{promptSource || "—"}</b>
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    <button type="button" className="btn btn-primary" onClick={openPromptModal}>
                      Promptları Düzenle
                    </button>
                  </div>
                </CardBody>
              </Card>

              {/* ---- Liste Kartı (Contact List) ---- */}
              {/* Buraya ContactList component'inin geri kalan render kısmı gelecek (Table vs.) 
                  Orijinal kodda Card içinde tablo vardı, buraya eklenebilir. 
                  Sadelik için burayı özet geçtim, orijinal koddaki tablo yapısı burada olmalı. */}
            </Col>
          </Row>
        </Container>
      </div>

      {/* DEĞİŞTİ: PROMPT DÜZENLE Modalı (Sekmeli) */}
      <Modal isOpen={promptModal} toggle={() => setPromptModal(false)} size="xl">
        <ModalHeader toggle={() => setPromptModal(false)} tag="h4">
          DLApass Prompt Konfigürasyonu (Firestore)
        </ModalHeader>
        <ModalBody>
          
          <Nav tabs className="nav-tabs-custom">
          
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => { toggleTab("2"); }}
                style={{ cursor: "pointer" }}
              >
                Simulation (Sınav) Modu
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => { toggleTab("3"); }}
                style={{ cursor: "pointer" }}
              >
                Practice (Pratik) Modu
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="p-3 text-muted">
            
            {/* TAB 1: Test Sonucu Promptu */}
          

            {/* TAB 2: Simulation Promptu */}
            <TabPane tabId="2">
              <div className="mb-3">
                <Label className="form-label text-danger">Simulation (Sınav) Modu Promptu</Label>
                <p className="text-muted font-size-12">
                  <b>LLM_DEGERLENDIRME_KRITERLERI_VE_PROMPT_V2.pdf</b> standartlarına göre hazırlanmış, katı kurallı sınav promptudur.
                </p>
                <Input
                  type="textarea"
                  rows="16"
                  value={prompts.simulation}
                  onChange={e => setPrompts({ ...prompts, simulation: e.target.value })}
                  disabled={promptLoading}
                  style={{ fontFamily: "monospace", fontSize: "12px" }}
                />
              </div>
            </TabPane>

            {/* TAB 3: Practice Promptu */}
            <TabPane tabId="3">
              <div className="mb-3">
                <Label className="form-label text-success">Practice (Pratik) Modu Promptu</Label>
                <p className="text-muted font-size-12">
                  <b>PRACTICE_VS_SIMULATION_FEEDBACK_STANDART.pdf</b> standartlarına göre hazırlanmış, tek cümlelik kısa feedback promptudur.
                </p>
                <Input
                  type="textarea"
                  rows="16"
                  value={prompts.practice}
                  onChange={e => setPrompts({ ...prompts, practice: e.target.value })}
                  disabled={promptLoading}
                  style={{ fontFamily: "monospace", fontSize: "12px" }}
                />
              </div>
            </TabPane>

          </TabContent>

          <div className="d-flex justify-content-between mt-3 border-top pt-3">
            <button 
              type="button" 
              className="btn btn-outline-warning" 
              onClick={fillDefaultCurrentTab} 
              disabled={promptLoading || promptSaving}
            >
              Aktif Sekmeyi Varsayılanla Sıfırla
            </button>
            <div className="d-flex gap-2">
              <button type="button" className="btn btn-light" onClick={() => setPromptModal(false)} disabled={promptSaving}>
                İptal
              </button>
              <button type="button" className="btn btn-primary" onClick={savePrompt} disabled={promptSaving || promptLoading}>
                {promptSaving ? "Tümünü Kaydediliyor..." : "Tüm Değişiklikleri Kaydet"}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);